import { useTheme } from '@/common/hooks';
import { Version } from '@/common/enums';

export const useVersion = () => {
  const { version } = useTheme();

  const isV1 = version === Version.V1;
  const isV2 = version === Version.V2;

  return {
    version,
    isV1,
    isV2,
  };
};